var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',{staticClass:"dragArea",attrs:{"tag":"ul","list":_vm.tasks,"group":{ name: 'g1' }}},_vm._l((_vm.tasks),function(el){return _c('li',{key:el.name},[_c('p',[_vm._v(_vm._s(el.name))]),_vm._v(" "),_c('nested-draggable',{attrs:{"tasks":el.tasks}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b1b544c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/infra/nested.vue
// module id = null
// module chunks = 